import { IOption } from '../../../models/IOption';
import { Component, Input, OnInit, Output } from '@angular/core';
import { EventEmitter } from '@angular/core';


@Component({
  selector: 'ff-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss']
})
export class DropdownComponent implements OnInit {

  /**
   * Text for dropdown placeholder
   * Default value: option
   * @internal
   */
  @Input() element: string = 'Option';
  /**
   * Options to display as radio buttons
   * Use the IOption interface: { value: string; text: string; selected?: boolean; }
   * @internal
  */
  @Input() options: IOption[] = [];

  /**
   * The default selected value of the dropdown
   */
  @Input() set default(option: IOption) {
    if (this.selectedValue.value !== option?.value) {
      if (this.selectedValue.value === '') {
        this.selectedValue = option;
      } else {
        this.selectedValue = option;
        this.onSelectionChange();
      }
    }
  }

  /**
   * Emit the value selected by the user
   * @internal
   */
  @Output() elementSelected = new EventEmitter<IOption>();

  /**
   * Emits when the dropdown menu is opened
   */
  @Output() opened = new EventEmitter();

  /**
   * Emits when the dropdown menu is closed
   */
  @Output() closed = new EventEmitter();

  selectedValue: IOption = {
    text: '',
    value: '',
    selected: false
  };


  constructor() { }

  ngOnInit(): void {  }

  compare(o1?: IOption, o2?: IOption) {
    return o1?.value === o2?.value;
  }

  onOpened($event): void {
    this.opened.emit($event);
  }

  onClosed($event): void {
    this.closed.emit($event);
  }

  onSelectionChange = (): void =>{
    console.log("Selected value:", this.selectedValue);
    this.elementSelected.emit(this.selectedValue);
  }

}
